import React from 'react'
import { connect } from 'react-redux'
import { Field, reduxForm } from 'redux-form'
import { bindActionCreators } from 'redux'
import { SubmissionError } from 'redux-form'
import LoadingProgress from '../components/LoadingProgress'

import { fetchAudits } from '../actions/audits'
import { fetchMachines } from '../actions/machines'

import { renderInputField, renderSelectField } from '../utils/forms'

class AuditFilterForm extends React.Component {
  constructor(props) {
    super(props)

    this.state = { loaded: false }

    this.submit = this.submit.bind(this)
  }

  componentDidMount() {
    const { fetchMachines } = this.props

    fetchMachines()

    this.load(this.props)
  }

  componentWillReceiveProps(nextProps) {
    this.load(nextProps)
  }

  load(props) {
    const { machines } = props

    if (!this.state.loaded && machines) {
      this.setState({ loaded: true })
    }
  }

  submit(props) {
    return this.props.fetchAudits(props.Machine, props.Type, props.StartDate, props.EndDate)
      .then(response => {
        if (response.error) {
          throw new SubmissionError({
            _error: response.error.message,
            ...response.error.fields
          })
        }

        return response
      })
  }

  render() {
    const { loaded } = this.state
    const { error, submitting, handleSubmit, machines } = this.props

    if (!loaded) {
      return <LoadingProgress />
    }

    return (
      <form onSubmit={handleSubmit(this.submit)}>
        <div className="audit-filter-grid no-customer">
          <div className="audit-filter-group">
            <Field name="Machine" component={renderSelectField} label="Máquina">
              <option value="">Todas</option>
              {machines.map(machine => (
                <option value={machine._id} key={machine._id}>{machine.Serial}</option>
              ))}
            </Field>
          </div>
          <div className="audit-filter-group">
            <Field name="Type" component={renderSelectField} label="Tipo">
              <option value="">Todas</option>
              <option value="INFO">INFO</option>
              <option value="LOGIN">LOGIN</option>
              <option value="ERROR">ERROR</option>
              <option value="MONEY">MONEY</option>
              <option value="CHANGE">CHANGE</option>
              <option value="INFO_LOCKERS">INFO LOCKERS</option>
              <option value="ERROR_LOCKERS">ERROR LOCKERS</option>
            </Field>
          </div>
          <div className="audit-filter-group">
            <Field name="StartDate" component={renderInputField} type="date" label="Fecha inicio" />
          </div>
          <div className="audit-filter-group">
            <Field name="EndDate" component={renderInputField} type="date" label="Fecha fin" />
          </div>
          <div className="audit-filter-group audit-filter-action">
            <button className="audit-filter-submit" type="submit" disabled={submitting}>
              <i className="fas fa-sync mr-1"></i>Actualizar
            </button>
          </div>
        </div>
        {error && <div className="alert alert-danger mt-2">{error}</div>}
      </form>
    )
  }
}

AuditFilterForm = reduxForm({
  form: 'AuditFilterForm',
})(AuditFilterForm)

const mapStateToProps = state => ({
  machines: state.machines.machines,
  initialValues: {
    Machine: '',
    Type: '',
    StartDate: new Date().toISOString().substring(0, 10),
    EndDate: new Date().toISOString().substring(0, 10)
  }
})

const mapDispatchToProps = dispatch => ({
  fetchAudits: bindActionCreators(fetchAudits, dispatch),
  fetchMachines: bindActionCreators(fetchMachines, dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(AuditFilterForm)

